RivalIQ.apps.Insights.module('models', function (models, App, Backbone, Marionette, $, _) {

    'use strict';

    models.LinkedInPresence = Backbone.Model.extend({
    });

    models.LinkedInConfiguration = Backbone.Model.extend({
    });
});
